import he from "he";
import { BaseService } from "../base-service";
import { API_BASE_URL } from "../../config";
import type {
  CatalogItemsParams,
  GetItemsResponse,
  AmazonianHardwareWithTaxonomyID,
} from "./catalog.types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function decodeHtmlEntityDeep(value: any): any {
  if (typeof value === "string") {
    return he.decode(he.decode(value.replace(/&amp;/g, "&").replace(/&amp;/g, "&")));
  }
  if (Array.isArray(value)) {
    return value.map(decodeHtmlEntityDeep);
  }
  if (typeof value === "object" && value !== null) {
    const decoded: Record<string, unknown> = {};
    for (const key of Object.keys(value)) {
      decoded[key] = decodeHtmlEntityDeep(value[key]);
    }
    return decoded;
  }
  return value;
}

export class CatalogService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private buildQueryParams(params: Record<string, any>): URLSearchParams {
    return new URLSearchParams(
      Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== "")
        .map(([key, value]) => [key, String(value)])
    );
  }

  public async getItem(taxonomyId: string): Promise<AmazonianHardwareWithTaxonomyID> {
    const plainId = taxonomyId.startsWith("atn::") ? taxonomyId.substring(5) : taxonomyId;
    const response = await this.fetch(`/cat-amznham/item/${plainId}`);
    if (!response.ok) throw new Error(`Catalog Item API error: ${response.status}`);
    const json = await response.json();
    return decodeHtmlEntityDeep(json.item ?? json);
  }

  public async getItems(
    params: CatalogItemsParams
  ): Promise<GetItemsResponse<AmazonianHardwareWithTaxonomyID>> {
    const queryParams = this.buildQueryParams(params);
    const response = await this.fetch(`/cat-amznham/items/amznham/?${queryParams.toString()}`);
    if (!response.ok) throw new Error(`Catalog API error: ${response.status}`);
    return decodeHtmlEntityDeep(await response.json());
  }
}
